module.exports = __webpack_public_path__ + "static/media/buttonclickrelease.1bead507.wav";